export default __webpack_public_path__ + "static/media/etapa1.01acb4dc.png";